import { AntTagColor } from '@agro-club/agroclub-shared'
import { SampleDetailed, SampleForList, SampleReactionStatus, SampleStatus } from './types'
import { differenceInHours, formatDuration, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'
import { DASH } from 'modules/constants'

export const statusColorMap: Record<string, AntTagColor> = {
  [SampleStatus.archived]: 'grey',
  [SampleStatus.in_progress]: 'blue',
  [SampleStatus.published]: 'green',
  [SampleStatus.canceled]: 'red',
}

export const formatExactTimeLeft = (dateString: string) => {
  const hoursDiff = differenceInHours(parseISO(dateString), new Date())
  const absDiff = Math.abs(hoursDiff)
  const days = Math.trunc(absDiff / 24)
  const hours = absDiff % 24
  return formatDuration({ days, hours }, { locale: ru })
}

export const getSampleTimeLeft = (sample: SampleDetailed | SampleForList, t) => {
  let formatedTimeDelta
  let delta = 1
  if (sample.reaction_status === SampleReactionStatus.paused) {
    if (sample.time_left_for_reaction) {
      const hoursLeft = Math.trunc(sample.time_left_for_reaction / 60)
      const days = Math.trunc(hoursLeft / 24)
      const hours = hoursLeft % 24
      formatedTimeDelta = formatDuration({ days, hours: hours }, { locale: ru })
    }
  } else if (sample.react_until) {
    formatedTimeDelta = formatExactTimeLeft(sample.react_until)
    const parsedDate = parseISO(sample.react_until)
    delta = parsedDate.getTime() - Date.now()
  } else {
    return null
  }
  let text = DASH
  if (formatedTimeDelta) {
    text = `${delta > 0 ? t('left') : t('passed')} ${formatedTimeDelta}`
  }
  return { text, delta }
}
